<template id="vue-stepper">
  <div style="position: relative;">
    <div class="flex-container container">
      <!-- <div style="display: contents;
    position: relative;"> -->
          <!-- <div class="progress1" :style="pBarSize">
            <div class="progress-bar1"
                role="progressbar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="progress">
            </div>
          </div> -->
      
      <!-- <div class="step stepFixed"
           v-for="(step, i) in steps"
           :key="i"
           :class="{ done: step.number < currentStep, current: step.number === currentStep }">
        <div class="step-number"
             :id="'step-'+step.number"
             v-on:click="moveStep(step.number)">
          <i v-if="step.number < currentStep" class="fa fa-check"></i>
          <span v-else>{{step.number}}</span>
        </div>
        <div class="step-label">{{step.label}}</div>
      </div> -->
      <!-- </div> -->
      
      
    </div>
    <!-- <div class="progress1" :style="pBarSize">
            <div class="progress-bar1"
                role="progressbar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="progress">
            </div>
    </div> -->
    <div class="container">
      <slot name="test"></slot>
      <div class="col-sm-12" v-if="currentStep > 0 && currentStep <= steps.length">
        <button v-if="currentStep > 1"
                v-on:click="moveStep(currentStep-1)"
                class="btn btn-default"
                role="button" style="position:absolute">
                <!-- <i class="fa fa-chevron-left" aria-hidden="true"></i>  -->
                Back</button>
        <button v-if="currentStep < steps.length"
                v-on:click="moveStep(currentStep+1)"
                class="btn btn-default pull-right float-right"
                role="button">Continue 
                <!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
                </button>
        <!-- <button v-else-if="currentStep == steps.length"
                v-on:click="finalize"
                class="btn btn-default pull-right"
                role="button">Submit</button> -->
      </div>
      <div v-else>
        <button v-on:click="moveStep(1)"
                class="btn btn-default btn-block"
                role="button" >Reset <i class="fa fa-refresh" aria-hidden="true"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "vue-stepper",
  props: { value: Array, curStep:Number},
  data: () => ({ steps: [], pBarSize: '', currentStep: 1 }),
  mounted() {
    
    if (!this.value || this.value.length == 0) {
      return;
    }
    this.currentStep = this.curStepFeedbackForm;
    this.steps = this.value
      .map((s, i) => ({ number: i+1, selected: false, ...s}) );
    
    this.steps[0].selected = true;
    
    this.$nextTick(() => {
      this.calculateBarPosition();
    });
    
    window.addEventListener('resize', this.calculateBarPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateBarPosition);
  },
  computed: {
    ...mapState(["curStepFeedbackForm"]),
    ...mapGetters(["curStepFeedbackForm"]),
    progress() {
      if (this.currentStep > this.steps.length) {
        return `width: 100%`;
      }
      const first = document.getElementById('step-1');
      const current = document.getElementById(`step-${this.currentStep}`);
      if (first && current) {
        const delta = current.getBoundingClientRect().right -first.getBoundingClientRect().right;
        return `width: ${delta}px;`;
      }
    }
  },
  methods: {
    moveStep(stepNumber) {
      this.currentStep = stepNumber;
      this.$store.commit("setCurStepFeedbackForm",stepNumber );
    },
    calculateBarPosition() {
      let docEl = document.documentElement;
      const first = document.getElementById('step-1');
      let rect = first.getBoundingClientRect();
      const offset = rect.left + (window.pageXOffset || docEl.scrollLeft || 0);
      //const top = rect.top + rect.height/2 - 2;
      const top =  rect.height/2+12;
      this.pBarSize = `left: ${offset}px; right: ${offset}px; top: ${top}px`;
    },
    finalize() {
      this.currentStep += 1;
    }
  }
}
</script>
<style>

</style>
